import './style.scss';
import { IProjectDocInfoMenu } from '../../../model/api-modules/document';
import { LanguageType } from '../../../model';

interface IProps {
  readonly hotDocument: ReadonlyArray<IProjectDocInfoMenu> | undefined;
  readonly joinPath: (
    projectId: string | number,
    docId?: string | number
  ) => void;
  readonly setSelectActive: (value: ReadonlyArray<number>) => void;
  readonly lang: LanguageType | null;
}

export const MostViewedDocumentation = (props: IProps) => {
  return (
    <div>
      <p className="c-title">
        {props.lang === LanguageType.EN
          ? 'Most Viewed Documentation'
          : '最受欢迎的内容'}
      </p>
      <ul className="c-hot-document">
        {props.hotDocument &&
          props.hotDocument.length > 0 &&
          props.hotDocument?.map((item: IProjectDocInfoMenu) => {
            return (
              <li
                key={item.id}
                onClick={() => {
                  props.joinPath(item.project_id, item.id);
                  props.setSelectActive([item.id]);
                }}
              >
                {item.name}
              </li>
            );
          })}
      </ul>
    </div>
  );
};
